/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOneBaseAodRunsControllerAodRunQueryResponse, GetOneBaseAodRunsControllerAodRunPathParams, GetOneBaseAodRunsControllerAodRunQueryParams } from "../models/GetOneBaseAodRunsControllerAodRun";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOneBaseAodRunsControllerAodRun } from "../axios/getOneBaseAodRunsControllerAodRun";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOneBaseAodRunsControllerAodRunQueryKey = (id: GetOneBaseAodRunsControllerAodRunPathParams["id"], params: GetOneBaseAodRunsControllerAodRunQueryParams = {}) => ["audit-reports-api", { url: '/aod-runs/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type GetOneBaseAodRunsControllerAodRunQueryKey = ReturnType<typeof getOneBaseAodRunsControllerAodRunQueryKey>

export function getOneBaseAodRunsControllerAodRunQueryOptions(id: GetOneBaseAodRunsControllerAodRunPathParams["id"], params?: GetOneBaseAodRunsControllerAodRunQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOneBaseAodRunsControllerAodRunQueryKey(id, params)
        return queryOptions<GetOneBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, GetOneBaseAodRunsControllerAodRunQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOneBaseAodRunsControllerAodRun(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a single AodRun
 * {@link /aod-runs/:id}
 */
export function useGetOneBaseAodRunsControllerAodRun<TData = GetOneBaseAodRunsControllerAodRunQueryResponse, TQueryData = GetOneBaseAodRunsControllerAodRunQueryResponse, TQueryKey extends QueryKey = GetOneBaseAodRunsControllerAodRunQueryKey>(id: GetOneBaseAodRunsControllerAodRunPathParams["id"], params?: GetOneBaseAodRunsControllerAodRunQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetOneBaseAodRunsControllerAodRunQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getOneBaseAodRunsControllerAodRunQueryKey(id, params)
         

         const query = useQuery({
          ...getOneBaseAodRunsControllerAodRunQueryOptions(id, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}